var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkInBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 13C10.9297 13.5741 11.4776 14.0491 12.1067 14.3929C12.7359 14.7367 13.4317 14.9411 14.1468 14.9923C14.862 15.0435 15.5798 14.9403 16.2515 14.6897C16.9233 14.4392 17.5333 14.047 18.0402 13.54L21.0402 10.54C21.951 9.59695 22.455 8.33394 22.4436 7.02296C22.4322 5.71198 21.9063 4.45791 20.9793 3.53087C20.0523 2.60383 18.7982 2.07799 17.4872 2.0666C16.1762 2.0552 14.9132 2.55918 13.9702 3.46997L12.2502 5.17997M14.5002 11C14.0707 10.4258 13.5228 9.95078 12.8936 9.60703C12.2645 9.26327 11.5687 9.05885 10.8535 9.00763C10.1384 8.95641 9.42061 9.0596 8.74885 9.31018C8.0771 9.56077 7.46709 9.9529 6.9602 10.46L3.9602 13.46C3.04941 14.403 2.54544 15.666 2.55683 16.977C2.56822 18.288 3.09407 19.542 4.02111 20.4691C4.94815 21.3961 6.20221 21.9219 7.51319 21.9333C8.82418 21.9447 10.0872 21.4408 11.0302 20.53L12.7402 18.82",
    stroke: "#374562",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkInBar);
export default __webpack_public_path__ + "static/media/link-in-bar.65dc2b90a00373616d1ee1eb06ec169c.svg";
export { ForwardRef as ReactComponent };